import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { SiteRolesUtil } from '~src/userManagement/services/resources/SiteRolesUtil';

export module Utils {
  export const isSiteExplorerOrHigher: () => boolean = () => {
    const siteSessionRole = SessionSiteSelectors.siteRole(getAppStore().getState());
    return siteSessionRole ? SiteRolesUtil.isSiteExplorerOrHigher(siteSessionRole) : false;
  };
}
